// Utils
import { isWebBridgeSupported } from '@shopee/web-bridge-sdk';

// Types
import type { AddOrChangePasswordExitHandling } from '@shopee-user/business-customization-types';

// Enums
import { PasswordUseCase } from '@shopee-user/business-customization-types';

/**
 *
 * FE TD: https://confluence.shopee.io/x/z-jDpQ
 * For Change Password flow, we will logout user after credential change
 * For Add Password flow, we will keep the user logged in after credential change
 */
export function addOrChangePasswordExitHandling({
  nonce,
  isUserPasswordWebLogoutAfterCredentialChangeEnabled,
  webViewLogoutSuccessfully,
  webViewNotifyRefreshTokenAfterChangeCredentials,
  exitWithSuccess,
  safelyRedirectToNextUrlFromQueryString,
  passwordUseCase,
}: AddOrChangePasswordExitHandling) {
  if (isWebBridgeSupported()) {
    if (passwordUseCase === PasswordUseCase.ChangePassword) {
      webViewLogoutSuccessfully();
    } else {
      webViewNotifyRefreshTokenAfterChangeCredentials({ nonce });
      exitWithSuccess();
    }
  } else {
    safelyRedirectToNextUrlFromQueryString({
      ...(!isUserPasswordWebLogoutAfterCredentialChangeEnabled && {
        code: nonce,
      }),
    });
  }
}
